export default __webpack_public_path__ + "static/kcasLogo-1c4d0d14153a6e564954f6dab17f4712.png";